import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, message, Typography } from 'antd';
import React, { useState } from 'react';
import { apiService } from '../services/api';
import tokenManager from '../utils/tokenManager';
import { saveUserToLocalStorage } from '../utils/userUtils';

const { Title, Text } = Typography;

function Login({ onLoginSuccess }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  // const navigate = useNavigate(); // Удалено, так как не используется

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await apiService.login(values.username, values.password);
      const accessToken = response.data.access_token;

      // Сохраняем токен и нормализованные данные пользователя
      localStorage.removeItem('skip_demo_login');
      localStorage.setItem('token', accessToken);
      saveUserToLocalStorage(response.data.user, {
        username: values.username,
        token: accessToken,
        expires_in: response.data.expires_in
      });
      
      // Инициализируем менеджер токенов
      tokenManager.init();
      
      message.success('Успешный вход в систему!');
      
      // Уведомляем AuthGuard об успешном входе
      if (onLoginSuccess) {
        onLoginSuccess();
      } else {
        // Если callback недоступен, используем альтернативный способ
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        message.error('Неверное имя пользователя или пароль');
      } else if (error.code === 'ECONNREFUSED' || error.message === 'Network Error' || !error.response) {
        message.error('Сервер недоступен. Запустите бэкенд: web_interface/backend — python main.py (порт 8001)');
      } else {
        const detail = error.response?.data?.detail ?? error.response?.statusText ?? 'Ошибка входа в систему';
        message.error(typeof detail === 'string' ? detail : 'Ошибка входа в систему');
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          width: '100%',
          maxWidth: '400px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          borderRadius: '12px'
        }}
        styles={{ body: { padding: '40px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Title level={2} style={{ color: '#1890ff', marginBottom: '8px' }}>
            Proxy Manager
          </Title>
          <Text type="secondary">
            Войдите в систему управления прокси
          </Text>
        </div>

        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
          initialValues={{
            username: ''
          }}
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: 'Пожалуйста, введите имя пользователя!' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="Имя пользователя"
              autoComplete="username"
              style={{ borderRadius: '8px', height: '48px' }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Пожалуйста, введите пароль!' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Пароль"
              style={{ borderRadius: '8px', height: '48px' }}
              iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              icon={<LoginOutlined />}
              style={{ 
                height: '48px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Войти
            </Button>
          </Form.Item>
        </Form>


      </Card>
    </div>
  );
}

export default Login;
